<div class="app-shell">
  <!-- ===================== Top navigation ===================== -->
  <header class="top-bar">
    <div class="top-bar__brand" routerLink="/care-homes">
      <span class="top-bar__glyph">●</span>
      <span class="top-bar__name">Carepoint</span>
    </div>

    <nav class="main-nav">
      @for (item of navItems; track item.label) {
        @if (item.routerLink) {
          <a
            class="main-nav__link"
            [class.main-nav__link--disabled]="item.disabled"
            [routerLink]="item.routerLink"
            routerLinkActive="main-nav__link--active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </a>
        } @else {
          <span class="main-nav__link main-nav__link--disabled" [class.main-nav__link--disabled]="item.disabled">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </span>
        }
      }

      <div class="main-nav__end user-area">
        <span class="user-area__email">{{ currentUser() }}</span>
        <button
          pButton
          icon="pi pi-sign-out"
          label="Logout"
          class="p-button-text p-button-sm"
          (click)="logout()"
        ></button>
      </div>
    </nav>
  </header>

  <!-- ===================== Page content ===================== -->
  <main class="main-content">
    <router-outlet />
  </main>
</div>
